import React, {PropTypes} from 'react';

const IntroPanel = ({children, askQuestionClick}) => (
  <header className="intro-panel">
    <div className="intro-panel__body">
      <h1 className="heading heading--bold heading--xl margin-bottom-xs">Teacher Q&A</h1>
      <div className="intro-panel__cols">
        <div className="intro-panel__intro">
          <p>Have a question about anything connected to teaching?</p>
        </div>
        <div className="intro-panel__ask">
          <button type="button" className="tes-btn tes-btn--primary-v2 tes-btn--lg" onClick={askQuestionClick}>Ask a question</button>
        </div>
      </div>
    </div>
    <div className="intro-panel__footer">
      {children}
    </div>
  </header>
  );

IntroPanel.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
  askQuestionClick: PropTypes.func,
};

export default IntroPanel;
